"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObjectEmpty = exports.getObjectToQueryString = exports.deleteCookie = exports.getCookie = exports.setCookie = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const General_1 = __importDefault(require("./constants/General"));
const isObject_1 = __importDefault(require("lodash/isObject"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
/***************************************************************************/
// COOKIE HELPERS (required)
/**
 * Set cookie
 * @returns void
 */
const setCookie = (cname, cvalue, exminutes) => {
    js_cookie_1.default.set(cname, cvalue, {
        domain: General_1.default.COOKIE_DOMAIN,
        expires: exminutes,
    });
};
exports.setCookie = setCookie;
/**
 * Get cookie
 * @returns string
 */
const getCookie = (cname) => {
    return js_cookie_1.default.getJSON(cname);
};
exports.getCookie = getCookie;
/**
 * Delete cookie
 * @returns void
 */
const deleteCookie = (cname) => {
    js_cookie_1.default.remove(cname, { domain: General_1.default.COOKIE_DOMAIN });
};
exports.deleteCookie = deleteCookie;
/***************************************************************************/
// GENERAL HELPERS
/**
 * Takes in OBJECT of keys and values and return query string with & and ?
 *  OBJECT -> "?page=2&limit=10&filter=js"
 * @returns string
 */
const getObjectToQueryString = (obj) => {
    if (!(0, isObject_1.default)(obj)) {
        return '';
    }
    if ((0, isEmpty_1.default)(obj)) {
        return '';
    }
    const queryParam = '?' +
        Object.keys(obj)
            .map(key => {
            return `${key}=${encodeURIComponent(obj[key])}`;
        })
            .join('&');
    return queryParam;
};
exports.getObjectToQueryString = getObjectToQueryString;
/**
 * Takes in an OBJECT and checks if its either NULL, UNDEFINED or OBJECT has empty keys
 * @returns boolean
 */
const isObjectEmpty = (object) => {
    return (0, isEmpty_1.default)(object) || !Object.values(object).some(x => !(0, isEmpty_1.default)(x));
};
exports.isObjectEmpty = isObjectEmpty;
//# sourceMappingURL=utils.js.map